module.exports = __webpack_public_path__ + "static/media/5.c2c617b8.jpg";